import apiFetch from '@wordpress/api-fetch';
import { __ } from '@wordpress/i18n';
import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import Notification from "../../components/Notifications/Notification";
import navigateMenu from './NavigateMenu';
import './Header.scss';
const customStyles = {
    overlay: {
        backgroundColor:'#1115199E',
        zIndex: '99999',
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '720px',
        padding: '0px',
        borderRadius: '8px',
        border: '1px solid rgb(216, 217, 219)',
    },
};
Modal.setAppElement('#ultimate-security-settings');
export default function Header() {
    // Search Modal
    const [searchQuery, setSearchQuery] = useState("");
    // ultimate_security_ajax_obj.isPro
    
    const query = searchQuery.trim().toLowerCase();

    const filteredResults =
        query.length >= 3
        ? navigateMenu.filter(
            (item) =>
                // item.label.toLowerCase().includes(query) ||
                item.settings.some((setting) => setting.toLowerCase().includes(query))
            )
        : [];
    
    let subtitle;
    const [modalIsOpen, setIsOpen] = React.useState(false);

    function openModal() {
        setIsOpen(true);
    }

    function afterOpenModal() {
        // references are now sync'd and can be accessed.
        // subtitle.style.color = '#f00';
    }

    function closeModal() {
        setIsOpen(false);
    }


    const [info, setInfo] = useState(null);   
    useEffect(() => {
        const fetchInfo = async () => {
            try {
                const response = await apiFetch({ path: '/ultimate-security/v1/plugin-info' });
        
                // Save to localStorage
                localStorage.setItem("plusInfo", JSON.stringify(response));
        
                // Update state
                setInfo(response);
            } catch (error) {
                console.error("Error fetching info:", error);
            }
        };
        
        // Check if data is already in localStorage
        const storedInfo = localStorage.getItem("plusInfo");
        if (storedInfo) {
            setInfo(JSON.parse(storedInfo));
        } else {
            fetchInfo();
        }
    }, []);
     // Toggle notifications panel
     const [showNotifications, setShowNotifications] = useState(false);

    // Toggle notifications panel
    const toggleNotifications = (e) => {
        e.preventDefault();
        setShowNotifications(!showNotifications);
    };
    const handleLinkClick = (e, url) => {
        setIsOpen(false);
        setSearchQuery("");
    };
    return (
        <>
            <div className="ultimate-security-topbar background-purple-90 text-white">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-xl-5 mb-3 mb-xl-0">
                            <div className="d-flex justify-content-center justify-content-lg-start align-items-center topbar-left">
                                <img className="plugin-logo" src={ultimate_security_ajax_obj.imageUrl+'icon.svg'}/>
                                <div className="plugin-name pl-heading fw-700">{__( 'Ultimate Security', "ultimate-security" )}</div>
                                <ul className="d-flex align-items-center mb-0 gap-3 mt-2">
                                    { <li className="pl-heading-1 fw-600 dashboard-link">
                                        <Link to="/">
                                            <img src={ultimate_security_ajax_obj.imageUrl+'dashboard.svg'} alt="plugin-icon"/>
                                            {__( 'Dashboard', "ultimate-security" )}
                                        </Link>
                                    </li> }
                                    <li className="pl-heading-1 fw-600">
                                        <Link to="/login/active-logins/settings">
                                            <img src={ultimate_security_ajax_obj.imageUrl+'settings.svg'} alt="plugin-icon"/>
                                            {__( 'Settings', "ultimate-security" )}
                                        </Link>
                                    </li>
                                </ul>
                            </div>                        
                        </div>
                        <div className="col-xl-7">
                            <div className="row g-0 justify-content-center justify-content-lg-end align-items-center topbar-right">                                
                                <div className="col-auto header-logos">
                                    <a className='search-settings'
                                        onClick={openModal}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <img src={ultimate_security_ajax_obj.imageUrl+'search.svg'} alt="plugin-icon"/>
                                    </a>
                                </div>
                                <div className="col-auto header-logos">
                                    <a href="https://wordpress.org/support/plugin/ultimate-security/" target="_blank">
                                    <img src={ultimate_security_ajax_obj.imageUrl+'support.svg'} alt="plugin-icon"/>
                                    </a>
                                </div>
                                <div className="col-auto header-logos">
                                    <a href="https://wordpress.org/support/plugin/ultimate-security/reviews/#new-post" target="_blank">
                                        <img src={ultimate_security_ajax_obj.imageUrl+'featured.svg'} alt="plugin-icon"/>
                                    </a>
                                </div>
                                {/* <div className="col-auto header-logos notification">
                                    <a
                                        href="#"
                                        onClick={toggleNotifications}
                                        className={`nav-link ${showNotifications ? "active" : ""}`}
                                    >
                                        <img src={ultimate_security_ajax_obj.imageUrl+'notification.svg'} alt="plugin-icon"/>
                                    </a>
                                    
                                    {showNotifications && (
                                        <Notification onClose={() => setShowNotifications(false)} />
                                    )}
                                </div>
                                {/* <div className="col-auto topbar-right-unit">
                                    <a href="https://www.wpultimatesecurity.com" target="_blank">
                                        <img className="question" src={ultimate_security_ajax_obj.imageUrl+'pl_logo.svg'}/>
                                    </a>
                                </div> */}
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div 
                    className="search-box-wrapper"
                >
                    <div 
                        className="search-input-wrapper"
                    >
                        <img src={ultimate_security_ajax_obj.imageUrl+'search-input.svg'} alt="plugin-icon"/>
                        <input
                            type="text"
                            placeholder="Search settings..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                    
                    {
                        query.length >= 3 && (
                            <div className="nav-search-output" style={{ maxHeight: '256px', overflowY: 'auto', borderTop: '1px solid #D8D9DB' }}>
                                {
                                    query.length >= 3 && filteredResults.length === 0 && (
                                        <div>{__( 'No results found.', "ultimate-security" )}</div>
                                    )
                                }
                                {
                                    filteredResults.map((item, index) => (
                                        <a
                                            href={`/wp-admin/admin.php?page=ultimate-security#${item.url}`}
                                            onClick={(e) => handleLinkClick(e, `/wp-admin/admin.php?page=ultimate-security#${item.url}`)}
                                            key={index}

                                        >
                                            <strong>{item.label}</strong><br/>
                                            <span>{item.url}</span>
                                        </a>
                                    ))
                                }
                            </div>
                        )
                    }
                </div>
            </Modal>
        </>
    )
}
